<div class="report-view" id="report-view">
    <header class="report-actions" data-html2canvas-ignore>
        <mat-card>
            <mat-card-header>
                <mat-card-title>
                    <h2>{{ 'users.licenceBilling.title.shortLabel' | translate }}</h2>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <form (ngSubmit)="onSubmit()">
                    <mat-form-field>
                        <mat-label>{{ 'users.licenceBilling.file.shortLabel' | translate }}</mat-label>
                        <mat-select [(value)]="selectedType">
                            <mat-optgroup label="Belfius">
                                <mat-option value="billing">{{ 'users.licenceBilling.billing.shortLabel' | translate }}</mat-option>
                                <mat-option value="debit">{{ 'users.licenceBilling.debit.shortLabel' | translate }}</mat-option>
                                <mat-option value="billing+debit">{{ 'users.licenceBilling.billingDebit.shortLabel' | translate }}</mat-option>
                            </mat-optgroup>
                            <mat-optgroup label="Bizzdev">
                                <mat-option value="retrocession">{{ 'users.licenceBilling.retrocession.shortLabel' | translate }}</mat-option>
                            </mat-optgroup>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{ 'users.licenceBilling.year.shortLabel' | translate }}</mat-label>
                        <mat-select [(value)]="selectedYear">
                            <mat-optgroup label="{{ 'users.licenceBilling.archiveYear.shortLabel' | translate }}">
                                <mat-option *ngFor="let year of archiveYears" [value]="year">{{year}}</mat-option>
                            </mat-optgroup>
                            <mat-optgroup label="{{ 'users.licenceBilling.fullYear.shortLabel' | translate }}">
                                <mat-option *ngFor="let year of fullYears" [value]="year">{{year}}</mat-option>
                            </mat-optgroup>
                            <mat-optgroup label="{{ 'users.licenceBilling.partialYear.shortLabel' | translate }}">
                                <mat-option *ngFor="let year of partialYears" [value]="year">{{year}}</mat-option>
                            </mat-optgroup>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{ 'users.licenceBilling.month.shortLabel' | translate }}</mat-label>
                        <mat-select [(value)]="selectedMonth">
                            <mat-option value="april">{{ 'users.licenceBilling.april.shortLabel' | translate }}</mat-option>
                            <mat-option value="october">{{ 'users.licenceBilling.october.shortLabel' | translate }}</mat-option>
                            <mat-option value="all">{{ 'users.licenceBilling.allMonth.shortLabel' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button *ngIf="!isLoading; else loader" mat-raised-button color="accent" type="submit">
                        {{ 'users.licenceBilling.submit.shortLabel' | translate }}
                    </button>
                    <ng-template #loader>
                        <mat-spinner [diameter]="35" color="accent" class="spinner"></mat-spinner>
                    </ng-template>
                </form>
                <ng-template #noData>
                    <mat-spinner [diameter]="35" color="accent" class="spinner"></mat-spinner>
                </ng-template>
            </mat-card-content>
        </mat-card>
    </header>
</div>

<div class="mobile-message">
    <p>{{'main.mobileMessage.summary' | translate}}</p>
</div>
